// removed by extract-text-webpack-plugin
module.exports = {"Backdrop":"-name__-loca-__efy1y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Backdrop/Backdrop.css
// module id = 149
// module chunks = 0